module.exports = __webpack_public_path__ + "media/1-2.ebc90dda.mp3";